import { excelExportHttpClient } from './excelExportHttpClient';

export async function downloadManualImportFile(logId: string): Promise<{
    blob: Blob;
    fileName?: string;
}> {
    return excelExportHttpClient.getBlob(`/manual-imports/${logId}/file`);
}
